import React, { FC, SVGProps } from 'react';

export const User: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.4">
      <circle cx="12" cy="5.96928" r="5.16923" fill="#4F5950" />
      <ellipse cx="12" cy="22.3385" rx="11.2" ry="9.47692" fill="#4F5950" />
    </g>
  </svg>
);
